<template>
	<section v-if="items.length" class="promotions align-center">
		<slot name="blocks-header" />
		<div class="row">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column4">
				<div class="promotion">
					<nuxt-link class="image" :to="block.link">
						<picture>
							<source :srcset="block.imageWebp" type="image/webp" />
							<source :srcset="block.image" />
							<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
						</picture>
					</nuxt-link>
					<div class="content">
						<div class="inner">
							<h3>
								<nuxt-link :to="block.link">
									{{ block.header }}
								</nuxt-link>
							</h3>
							<div class="content-wrapper">
								<div v-parse-links v-html="block.content" />
								<p v-if="block.link">
									<nuxt-link :to="block.link" class="button no-fill" target="_self">
										{{ $t('readMore') }}
									</nuxt-link>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 9 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions {
	background-color: var(--secondary-background-color);

	.columns {
		display: flex;
	}
}

.promotion {
	margin: 0 auto 20px;
	position: relative;
	overflow: hidden;

	.content {
		padding: 30px;
		color: #fff;
		display: flex;
		flex-flow: column nowrap;
		justify-content: space-between;
		align-items: flex-start;
		height: 100%;
		position: relative;
		z-index: 2;
		left: 0;

		.inner {
			padding: 30px;
			border: 1px solid #fff;
			height: 100%;
			display: flex;
			flex-flow: column nowrap;
		}

		.button {
			color: #fff;
			border-color: #fff;

			&:hover {
				background: #fff;
				color: var(--cta-color);
			}
		}

		h3 {
			width: 100%;
			margin-bottom: 75px;

			a {
				text-decoration: none;
				color: #fff;
			}
		}

		.content-wrapper {
			width: 100%;
			margin-top: auto;
		}
	}

	.image {
		display: block;
		overflow: hidden;
		position: absolute;
		height: 100%;
		width: 100%;

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0;
			z-index: 1;
			background: rgb(0 0 0 / 40%);
			width: 100%;
			height: 100%;
		}

		img {
			transition: all 0.3s ease-in-out;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	&:hover .image img {
		transform: scale(1.05);
	}
}

@media (max-width: 1080px) {
	.promotions {
		padding: 50px 15px;
	}

	.promotion {
		.column6 {
			margin: 20px 0;
		}
	}
}

@media (max-width: 880px) {
	.columns {
		width: 100%;
	}

	.promotion {
		.content {
			padding: 20px;
		}
	}
}

@media (max-width: 580px) {
	.promotion {
		margin-bottom: 25px;

		.content {
			padding: 10px;
		}
	}
}
</style>
